import { render, staticRenderFns } from "./setting-company.vue?vue&type=template&id=15b97c2a&"
import script from "./setting-company.vue?vue&type=script&lang=js&"
export * from "./setting-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports